import type { ContentNode, DocumentState } from '../document-types';
import type { NodeHandler, RenderContext } from './types';

export class EmojiHandler implements NodeHandler {
  readonly type = 'emoji';

  render(
    node: ContentNode | DocumentState,
    _parent: ContentNode | DocumentState | null,
    _childContent: string,
    _ctx: RenderContext
  ): string {
    const name = (node as ContentNode).attrs?.['name'];
    if (typeof name !== 'string' || name === '') {
      return '';
    }
    return `:${name}:`;
  }
}
